import { atom } from 'jotai';
import { RegistrationTier } from '@/types/auction';

// null = modal closed; non-null = modal open for the selected tier
export const selectedTierForModalAtom = atom<RegistrationTier | null>(null);
